<!--
 * @Author: yinbing.liu
 * @Date: 2023-09-19 11:14:20
 * @LastEditors: yinbing.liu
 * @LastEditTime: 2023-09-19 15:14:16
 * @FilePath: /fushigi/src/components/ALink/index.vue
 * @Description:
-->
<template>
  <a v-if="isExternal(to)" :href="to" target="_blank" rel="noreferrer">
    <slot></slot>
  </a>
  <router-link v-else :to="to" :replace="replace">
    <slot></slot>
  </router-link>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { isExternal } from '@/utils/validate'
export default defineComponent({
  name: 'ALink',
  props: {
    to: {
      type: String,
      required: true,
    },
    replace: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      isExternal,
    }
  },
})
</script>
